export const baseUrl = '/api/v1/';
export const baseServletUrl = '/api/ica-rs';
export const baseAuthUrl = '/api/auth';
export const contentTypeGet = 'application/vnd.ica.api-1.0+json';
export const contentTypeOther = 'application/vnd.api+json';
export const stateTypeDirectTable = 'DIRECT_TABLE';
export const typeSystemStats = 'systemStats';
